module.exports = __webpack_public_path__ + "img/hopkins.d62200df.png";